export default {
    namespaced: true,
    state: {
        show: false,
        message: null,
        closeButtonText: 'Shut down',
        buttonText: null,
        buttonLink: null,
        persistent: false,
    },
    mutations: {
        setNotificationModalOptions(state, options) {
            if (options && typeof options === 'object') {
                if (options.message && typeof options.message === 'string') {
                    state.message = options.message;
                    state.show = true;
                }
                if (options.buttonText && typeof options.message === 'string') {
                    state.buttonText = options.buttonText;
                }
                if (options.closeButtonText) {
                    state.closeButtonText = options.closeButtonText;
                }
                if (options.buttonLink) {
                    state.buttonLink = options.buttonLink;
                }
                if (options.persistent) {
                    state.persistent = options.persistent;
                }
                if (
                    options.buttonCallback &&
                    typeof options.buttonCallback === 'function'
                ) {
                    state.buttonCallback = options.buttonCallback;
                }
            }
        },
        setShow(state, value) {
            state.show = value;
        }
    },
    actions: {
        displayNotificationModal({ commit }, options) {
            commit('setNotificationModalOptions', options);
            commit('setShow', true);
        }
    }
};
